export default {
  buttons: {
    done: 'Done',
  },
};
